export class LoginInfo {
  constructor(public username: string, public password: string) {}
}
